<template>
  <van-tabbar v-model="active"  class="active_tab" @change="tab">
    <van-tabbar-item
      v-for="(item,index) in tabbars"
      :key="index"
      :to="item.name"
      replace
      route
    >
      <span>{{item.title}}</span>
      <template slot="icon" slot-scope="props">
        <img :src="props.active ? item.active : item.normal">
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      active: 0,
      tabbars: [
        {
          title: '积分商城',
          name: `/integralMallList?token=${localStorage.getItem('token')}&companyId=${localStorage.getItem('companyId')}&active=0`,
          normal: require('@assets/images/shop_btn_shop_default.png'),
          active: require('@assets/images/shop_btn_shop_selected.png')
        },
        {
          title: '我的订单',
          name: `/myOrder?token=${localStorage.getItem('token')}&companyId=${localStorage.getItem('companyId')}&active=1`,
          normal: require('@assets/images/shop_btn_dingdan_default.png'),
          active: require('@assets/images/shop_btn_dingdan_selected.png')
        }
      ]
    }
  },
  mounted () {
    if (this.$route.query.active) {
      this.active = Number(this.$route.query.active)
    }
  },
  methods: {
    tab (index) {
      this.active = index
    }
  }
}
</script>

<style lang="scss">
  .integralMall{
    .van-tabbar-item__icon img{
      width: 20px;
    }
  }
</style>
